document.addEventListener('DOMContentLoaded', () => {
    initBuyNowBtnFunction();
    initTest();

    const search = document.querySelector('#search-form');
    search.addEventListener('change', (e) => {
        initTest();
    })
});

const scrollableElement = window || document.documentElement;
scrollableElement.addEventListener('scroll', debounce(initTest, 500));

/**
 * Trigger when Events Fires
 */
function initTest(){
    const quickBtns = document.querySelectorAll("a.quick-view__link")
    quickBtns.forEach(btn => {
        btn.addEventListener("click", ()=>{
            waitForElm(".qv__product").then(element => {
                initBuyNowBtnFunction();
            });
            
        })
    })
}

function initBuyNowBtnFunction() {
    const buyNowBtns = document.querySelectorAll(".buy-now-btn")
    buyNowBtns.forEach(btn => {
        btn.addEventListener("click", (el) => {
            btn.closest("form").setAttribute("data-buy-now", true);
        })
    })
}

function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }
        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                observer.disconnect();
                resolve(document.querySelector(selector));
            }
        });
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}

function debounce(func, delay) {
    let timerId;
  
    return function (...args) {
      if (timerId) {
        clearTimeout(timerId);
      }
  
      timerId = setTimeout(() => {
        func.apply(this, args);
        timerId = null;
      }, delay);
    };
  }